export const noopAsync = (): Promise<void> => Promise.resolve();
